import './styles.scss';

import React from 'react';
import PropTypes from 'prop-types';

import { TeamDisplay } from '@nhl/nhl-react-ui/lib/TeamDisplay';

const BasePlayerTeamInfo = ({player, team, season, infoItem = { useDescription: false }}) => {
    // some join on position, some do not
    const positionCode = player?.position?.positionCode || player?.position || '';
    const playerInfo = player?.sweaterNumber ? `# ${player.sweaterNumber} | ${positionCode}` : positionCode;
    return (
        <div className="player-info">
            {
                infoItem.useDescription ? <div className="info-item-description">{ infoItem.description }</div> : null
            }

            <div className="player-name">{ player ? `${player.firstName} ${player.lastName}` : 'Unknown Star' }</div>

            {
                team && (
                    <div className="player-team-info">
                        <TeamDisplay team={team} season={season} displayName={false} append={<div>{playerInfo}</div>} />
                    </div>
                )
            }
        </div>
    );
};

BasePlayerTeamInfo.propTypes = {
    player: PropTypes.shape({
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        sweaterNumber: PropTypes.number,
        position: PropTypes.any
    }),
    infoItem: PropTypes.shape({
        useDescription: PropTypes.bool,
        description: PropTypes.string
    })
};

export default BasePlayerTeamInfo;
